import React from "react";
import clsx from "clsx";

const frameStyles = {
    rustic: "rounded-[24px] border-2 border-accent/30 shadow-[0_10px_30px_rgba(0,0,0,0.3)] overflow-hidden",
    wood: "border-[6px] border-[#4a3321] rounded-2xl shadow-xl bg-[#121824] overflow-hidden",
    glow: "rounded-2xl border border-primary/40 shadow-[0_0_40px_rgba(233,69,69,0.15)] overflow-hidden",
    // 🚀 Variante Label aggiornata con le transizioni collegate all'hover del parent (.group)
    label: "relative border border-accent/30 rounded-3xl shadow-2xl overflow-hidden transition-all duration-500 group-hover:border-primary/40 group-hover:shadow-[0_0_40px_rgba(233,69,69,0.15)]",
};

const FramedImage = ({ src, alt = "", variant = "rustic", label, className = "" }) => {
    return (
        <div
            className={clsx(
                "relative w-full aspect-[4/3] sm:aspect-video lg:aspect-[4/3] overflow-hidden transition-all duration-500 ease-out",
                // Se usato da solo mantiene il suo hover alternativo, se usato nella lista si sincronizza
                variant !== "label" && "hover:scale-[1.015] hover:border-primary/30",
                frameStyles[variant],
                className
            )}
        >
            {/* Protezione contrasto per la scritta in alto */}
            {variant === "label" && label && (
                <div className="absolute inset-x-0 top-0 h-16 bg-gradient-to-b from-black/60 to-transparent z-10 pointer-events-none" />
            )}

            {/* Immagine con zoom morbido sincronizzato al movimento della card o della riga */}
            <img
                src={src}
                alt={alt}
                className="w-full h-full object-cover brightness-[1.02] contrast-[1.01] transition-transform duration-700 ease-out group-hover:scale-105"
                loading="lazy"
                draggable={false}
            />

            {/* Badge Premium posizionato nell'angolo */}
            {variant === "label" && label && (
                <div className="absolute top-3.5 right-3.5 bg-primary text-black text-[10px] font-black tracking-widest uppercase px-3 py-1.5 rounded-xl shadow-lg z-20 border border-white/10 transition-transform duration-500 group-hover:scale-105">
                    {label}
                </div>
            )}
            
            {/* Soft overlay scuro che pulisce lo sfondo e si dissolve in hover */}
            <div className="absolute inset-0 bg-black/10 opacity-100 group-hover:opacity-0 transition-opacity duration-500 pointer-events-none" />
        </div>
    );
};

export default FramedImage;